import { heroStats } from '@/mocks/darkwebData';

export default function HeroSection() {
  return (
    <section
      id="hero"
      className="relative min-h-screen flex items-center pt-[72px] overflow-hidden bg-background-50"
    >
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute -top-40 -right-40 w-[600px] h-[600px] rounded-full bg-primary-500/5 blur-3xl"></div>
        <div className="absolute -bottom-60 -left-40 w-[500px] h-[500px] rounded-full bg-accent-500/5 blur-3xl"></div>
      </div>

      <div className="w-full px-4 md:px-6 py-10 md:py-14 max-w-[1440px] mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="flex flex-wrap justify-center lg:justify-start gap-2 mb-5">
              {['暗网新闻', '黑市动态', '吃瓜爆料'].map((tag) => (
                <span
                  key={tag}
                  className="inline-block px-3 py-1 text-xs font-medium bg-primary-100/70 text-primary-700 rounded-full whitespace-nowrap"
                >
                  {tag}
                </span>
              ))}
            </div>

            <h1 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 leading-tight mb-4">
              51暗网 — 暗网新闻与黑市动态前沿追踪平台
            </h1>

            <p className="text-lg md:text-xl text-primary-600 font-heading font-semibold mb-6">
              第一时间，深度追踪暗网世界的每一个角落
            </p>

            <div className="text-foreground-600 text-sm md:text-base leading-relaxed space-y-3 mb-8 max-w-xl mx-auto lg:mx-0">
              <p>
                51暗网聚焦暗网新闻动态，实时追踪暗网黑市交易、网络犯罪事件与全球安全政策变化。从前沿勒索软件攻击到跨国数据泄露大案，从地下黑客组织活动到各国暗网执法行动，我们提供深度暗网事件解读与独家追踪报道。
              </p>
              <p>
                平台同时聚合吃瓜爆料内容，覆盖暗网内幕消息、名人隐私泄露追踪和各类网络安全趣闻。日均更新暗网快讯超过50条，7×24全天候情报监测，帮助每一位读者在暗网信息洪流中准确获取关键动态。
              </p>
            </div>

            <div className="flex flex-wrap justify-center lg:justify-start gap-6 md:gap-10 mb-8">
              {heroStats.map((stat) => (
                <div key={stat.label} className="text-center">
                  <div className="font-heading text-2xl md:text-3xl font-bold text-accent-500">
                    {stat.value}
                  </div>
                  <div className="text-xs text-foreground-600 mt-1">{stat.label}</div>
                </div>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row justify-center lg:justify-start gap-3">
              <a
                href="#updates"
                onClick={(e) => {
                  e.preventDefault();
                  document.getElementById('updates')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="inline-flex items-center justify-center h-11 px-6 bg-primary-500 text-background-50 font-medium text-sm rounded-md hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
              >
                浏览最新动态
                <i className="ri-arrow-right-line ml-2"></i>
              </a>
              <a
                href="#contact"
                onClick={(e) => {
                  e.preventDefault();
                  document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="inline-flex items-center justify-center h-11 px-6 border border-background-300 text-foreground-700 font-medium text-sm rounded-md hover:bg-background-100 hover:border-foreground-400 transition-colors duration-200 whitespace-nowrap cursor-pointer"
              >
                加入追踪社群
                <i className="ri-mail-line ml-2"></i>
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-[520px]">
            <div className="relative rounded-lg overflow-hidden aspect-[4/3] bg-background-200">
              <img
                src="https://readdy.ai/api/search-image?query=Dark%20web%20news%20portal%20hero%20visual%2C%20abstract%20cyber%20security%20concept%20with%20interconnected%20nodes%20and%20data%20streams%2C%20dark%20sophisticated%20aesthetic%20with%20deep%20crimson%20accents%2C%20editorial%20style%2C%20dramatic%20contrast%20lighting%2C%20modern%20news%20media%20art%20direction&width=800&height=600&seq=hero-main&orientation=landscape"
                alt="51暗网 - 暗网新闻与黑市动态前沿追踪平台主题视觉"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/40 via-transparent to-transparent"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}